import React from "react";
import { PageRoute } from "@quest-finance/quest-fe-shared/dist/common/types/PageRoute";

const ApplicationDetailsPage = React.lazy(
  () => import("../pages/ApplicationDetails")
);
const ApplicationList = React.lazy(() => import("../pages/ApplicationList"));
const LenderList = React.lazy(() => import("../pages/LenderList"));
const LenderAdmin = React.lazy(() => import("../pages/LenderAdmin"));

const routes: PageRoute[] = [
  {
    name: "Application Details",
    path: "/application/applications/:applicationId/:tabName",
    exact: true,
    component: ApplicationDetailsPage,
  },
  {
    name: "Application List",
    path: "/application/applications",
    exact: true,
    component: ApplicationList,
  },
];

const antdRoutes: PageRoute[] = [
  {
    name: "Lender List",
    path: "/application/lenders",
    exact: true,
    component: LenderList,
  },
  {
    name: "Lender Admin",
    path: "/application/lenders/:lenderId/admin",
    exact: true,
    component: LenderAdmin,
  },
];

export default routes;
export { antdRoutes };
